import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const SalesPortalLastPurchaseInfoDocument = gql`
  query SalesPortalLastPurchaseInfo($chatUUID: uuid!) {
    getVariantPackLastPurchaseInfo(chat_id: $chatUUID) {
      fulfillment_date
      order_date
      quantity
      variant_pack_id
    }
  }
`;
export function useSalesPortalLastPurchaseInfoQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SalesPortalLastPurchaseInfoQuery,
    Types.SalesPortalLastPurchaseInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SalesPortalLastPurchaseInfoQuery,
    Types.SalesPortalLastPurchaseInfoQueryVariables
  >(SalesPortalLastPurchaseInfoDocument, options);
}
export function useSalesPortalLastPurchaseInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SalesPortalLastPurchaseInfoQuery,
    Types.SalesPortalLastPurchaseInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SalesPortalLastPurchaseInfoQuery,
    Types.SalesPortalLastPurchaseInfoQueryVariables
  >(SalesPortalLastPurchaseInfoDocument, options);
}
export type SalesPortalLastPurchaseInfoQueryHookResult = ReturnType<
  typeof useSalesPortalLastPurchaseInfoQuery
>;
export type SalesPortalLastPurchaseInfoLazyQueryHookResult = ReturnType<
  typeof useSalesPortalLastPurchaseInfoLazyQuery
>;
export type SalesPortalLastPurchaseInfoQueryResult = Apollo.QueryResult<
  Types.SalesPortalLastPurchaseInfoQuery,
  Types.SalesPortalLastPurchaseInfoQueryVariables
>;

/**
 * Wrapped version of useGeneratedSalesPortalLastPurchaseInfoQuery using Pepper's useWrappedQuery
 */
export function useGeneratedSalesPortalLastPurchaseInfoQuery(
  options?: Apollo.QueryHookOptions<
    Types.SalesPortalLastPurchaseInfoQuery,
    Types.SalesPortalLastPurchaseInfoQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.SalesPortalLastPurchaseInfoQuery,
    Types.SalesPortalLastPurchaseInfoQueryVariables
  >(SalesPortalLastPurchaseInfoDocument, options);
}

/**
 * Wrapped version of useGeneratedSalesPortalLastPurchaseInfoLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedSalesPortalLastPurchaseInfoLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.SalesPortalLastPurchaseInfoQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.SalesPortalLastPurchaseInfoQuery,
    Types.SalesPortalLastPurchaseInfoQueryVariables
  >(SalesPortalLastPurchaseInfoDocument, lazyOptions);
}
